module.exports = __webpack_public_path__ + "static/media/icon-card.a29f5d4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-card.svg
// module id = 2895
// module chunks = 0